import React from "react";
import ToolOutput from "./ToolOutput";
export default function McpToolCard({ payload, result }) {
  return (
    <div className="tool-card-body">
      <div className="tool-section">
        <h5>{payload?.server_name ? `via ${payload.server_name} · input` : "input"}</h5>
        <pre className="tool-pre">{JSON.stringify(payload?.input ?? {}, null, 2)}</pre>
      </div>
      {result && (
        <div className="tool-section">
          <h5>Output {result.is_error ? "(error)" : ""}</h5>
          <ToolOutput text={result.content_preview} />
        </div>
      )}
    </div>
  );
}
// Summary column shows the MCP server when known, else the input field names —
// the server_name from agent.mcp_tool_use events is often absent, so don't lead with "::".
McpToolCard.summarize = (p) => {
  if (p?.server_name) return p.server_name;
  const keys = Object.keys(p?.input || {});
  return keys.length ? keys.join(", ") : (p?.name || "tool call");
};
